const dev_url = "https://test.yulin365.net/api/v1";
const dev_url1 = "http://192.168.0.118:80/api/v1";

const prod_url = "https://www.yulin365.net/api/v1";
export default {
  api_base_url: prod_url,
};



// WEBPACK FOOTER //
// ./src/request/config.js